module.exports = "<div #map [style.height]=\"height\" [style.width]=\"width\"></div>\n"